module.exports = __webpack_public_path__ + "static/media/handShakeWhite.5ced1935.svg";